export default __webpack_public_path__ + "static/article-diy-car-maintenance-jobs-687f8fcaae24bb67c944bc66def11f6c.jpg";